export const SESSION_STORAGE_KEYS = {
  IMPERSONATION_USER: 'impersonationUser',
  NERVENET_NEXT_STEP_DISMISSED: 'nervenet_next_step_dismissed',
};
